module.exports = require('../dist/src/lazy');
